export function lanzarFlyOut(
  alias,
  customParamName,
  customParamValue,
  customParamName2,
  customParamValue2
) {
  let pasarRecom = false;
  let creatividadFlyOut = '';

  if (typeof recom !== 'undefined') {
    if (recom.length > 0) {
      pasarRecom = true;
      console.log('Pasando recom');
    }
  } else {
    console.log('No pasando recom');
  }
  if (
    customParamName == undefined
    || customParamValue == undefined
    || customParamValue == ''
  ) {
    creatividadFlyOut = `<div class='customizer' ctz-creativity='${
      alias
    }' ctz-backup='${
      alias
    }'>&nbsp;</div>`;
  } else if (
    customParamName2 == undefined
      || customParamValue2 == undefined
      || customParamValue2 == ''
  ) {
    if (
      customParamValue[0] != 'a'
        && customParamValue[1] != ':'
        && customParamValue[2] != ':'
    ) {
      if (!pasarRecom) {
        creatividadFlyOut = `<div class='customizer' ctz-creativity='${
          alias
        }' ctz-custom-values="{'${
          customParamName
        }':'a::${
          customParamValue
        }'}" ctz-backup='${
          alias
        }'>&nbsp;</div>`;
      } else {
        creatividadFlyOut = `<div class='customizer' ctz-creativity='${
          alias
        }' ctz-custom-values="{'${
          customParamName
        }':'a::${
          customParamValue
        }','cv_ruleInfo':'`
            + `promoCode=${
              recom[0].promoCode
            }'}" ctz-backup='${
              alias
            }'>&nbsp;</div>`;
      }
    } else if (!pasarRecom) {
      creatividadFlyOut = `<div class='customizer' ctz-creativity='${
        alias
      }' ctz-custom-values="{'${
        customParamName
      }':'${
        customParamValue
      }'}" ctz-backup='${
        alias
      }'>&nbsp;</div>`;
    } else {
      creatividadFlyOut = `<div class='customizer' ctz-creativity='${
        alias
      }' ctz-custom-values="{'${
        customParamName
      }':'${
        customParamValue
      }','cv_ruleInfo':'`
            + `promoCode=${
              recom[0].promoCode
            }'}" ctz-backup='${
              alias
            }'>&nbsp;</div>`;
    }
  } else if (
    customParamValue2[0] != 'a'
        && customParamValue2[1] != ':'
        && customParamValue2[2] != ':'
  ) {
    creatividadFlyOut = `<div class='customizer' ctz-creativity='${
      alias
    }' ctz-custom-values="{'${
      customParamName
    }':'a::${
      customParamValue
    }','${
      customParamName2
    }':'${
      customParamValue2
    }'}" ctz-backup='${
      alias
    }'>&nbsp;</div>`;
  } else {
    creatividadFlyOut = `<div class='customizer' ctz-creativity='${
      alias
    }' ctz-custom-values="{'${
      customParamName
    }':'${
      customParamValue
    }','${
      customParamName2
    }':'${
      customParamValue2
    }'}" ctz-backup='${
      alias
    }'>&nbsp;</div>`;
  }
  console.log(creatividadFlyOut);
  console.log(customParamName);
  console.log(customParamValue);
  console.log(customParamName2);
  console.log(customParamValue2);
  document.getElementById('flyOutContainer').innerHTML = creatividadFlyOut;

  IC.reloadCustomizer(undefined, false);
}
